import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { browserHistory } from 'react-router';
import Cookies from 'universal-cookie';
import {cookieAuth} from '../actions/GlobalActions';

import HeaderPage from '../containers/HeaderPage';
import Footer from '../components/AppLayout/Footer';
import Notifications from 'react-notification-system-redux';

const userTypes = require('../constants/userTypes');
const theme = {
  DAILYROSTER: 'DAILYROSTER',
};

import '../styles/bootstrap.css';

import {Row, Col, Image} from 'react-bootstrap/lib/';

class AppContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      chooseVersion: false,
    };
  }

  /**
   *
   * these are functions to determine what page we are on. Eventually we should
   * make these constants with a switch statement
   */

  //admin and tabs are determined by these functions rather than by the state
  //because they are determined by the URL, and keeping track of it in two
  // places would be a mistake as they can get easily out of synch
  isAdmin(){
    return (this.props.location.pathname === 'admin') || (this.props.location.pathname === '/admin');
  }

  isUser(){
    return (this.props.location.pathname === 'dashboard') || (this.props.location.pathname === '/dashboard');
  }

  isTimeClock(){
    return (this.props.location.pathname === 'timeclock') || (this.props.location.pathname === '/timeclock');
  }

  isOrgMan(){
    return (this.props.location.pathname === 'orgman') || (this.props.location.pathname === '/orgman');
  }

  getTabs(){
    return this.props.headerTabs || [];
  }
  /**********************************************************************/




  componentDidUpdate(prevProps) {
    const isLoggingOut = prevProps.isLoggedIn && !this.props.isLoggedIn;
    const isLoggingIn = !prevProps.isLoggedIn && this.props.isLoggedIn;

    if (isLoggingIn) {
      const { details } = this.props;
      if(details.version == 4 && details.url){
        const cookies = new Cookies();
        cookies.set('domain', details.url);
        window.location.href = this.validateUrl(details.url);
      }else if (details.version == "choice"){
        this.setState({chooseVersion: true});
      }else {
        browserHistory.push(prevProps.redirectUrl);
      }
    } else if (isLoggingOut) {
      // do any kind of cleanup or post-logout redirection here
      browserHistory.push('login'+window.location.search);
    }


    //don't allow timeclock users to access admin and user pages, and visa versa
    if(this.props.userType === userTypes.TIMECLOCK && (this.isAdmin() || this.isUser())){
      browserHistory.replace('timeclock');
    }

    if(this.props.userType !== userTypes.TIMECLOCK && this.isTimeClock()){
      browserHistory.replace('dashboard');
    }

    //only allow super user to access orgman
    if(this.props.userType !== userTypes.SUPER && this.isOrgMan()){
      browserHistory.replace('dashboard');
    }
  }

  componentDidMount() {
    const cookies = new Cookies();
    if(cookies.get('ndAPIKey') && cookies.get('ndUserType')) {
      this.props.cookieAuth(cookies.get('ndAPIKey'), cookies.get('ndUserType'));
    }
  }

  validateUrl(url){
    if(url.indexOf("http") != -1){
      return url;
    }else {
      return `http://${url}`;
    }
  }

  handleVersionSelected(choice){
    if(choice.version_no == 4){
      /* Tell Allen to include "http://" or "https://" accordingly in the URL
      ** and to include a token in the URL. */
      window.location.href = this.validateUrl(choice.version_url);
    }else {
      this.setState({chooseVersion: false});
    }
  }

  getVersionDialog(){
    const choices = Object.keys(this.props.details.url).map(vn => {
      let label = "Version " + vn;
      if(this.props.details.label){
        label = this.props.details.label[vn] || ("Version " + vn)
      }
      return {
        version_no: vn,
        version_url: this.props.details.url[vn],
        label,
      }
    });
    return (
      <div id="version-wrapper">
        <div className="version-selection-wrapper">
          <span className="selection-title">You have both versions available</span>
          <span className="selection-sub-text">Select one to complete the login</span>
        </div>
        {choices.map(choice =>
          <div key={choice.version_no} className="version-choice" onClick={() => this.handleVersionSelected(choice)}>
            <h2>{choice.label}</h2>
          </div>
        )}
      </div>
    );
  }

  render() {
    if(this.state.chooseVersion && this.props.details){
      return (
        <div>
          <div id="topContainer">
            <div className="innerContainer">
              <div className="container-fluid" style={{padding:'0'}}>
                <div id="headerRow" className="nd-row">
                  <Col xs={6}>
                    <Image src={require('../img/netDutyLogo.png')} id="headerLogo" style={{float:'left', paddingBottom : '3px'}} />
                  </Col>
                </div>
              </div>
            </div>
          </div>
          {this.getVersionDialog()}
            <div style={{position:'fixed', left:'0', bottom:'5px', width:'100%'}}>
              <Row><Footer /></Row>
            </div>
        </div>
      );
    }
    if(this.state) {
      let themeClass = "";
      if(!this.props.isLoggedIn && this.props.style && this.props.style.config && this.props.style.config.theme){
        if(this.props.style.config.theme.toUpperCase() == theme.DAILYROSTER){
          themeClass = theme.DAILYROSTER;
        }
      }
      const login_background = {
        backgroundImage: `url(${require('../img/calendar_mouse.jpg')})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      };
      let displayData;
      if(this.props.style){
        displayData = this.props.style.config ? this.props.style.config.header : null
      }
      return (
        <div>
          <div id="topContainer" className={"header " + themeClass}>
            <HeaderPage
              currentPage={this.props.location.pathname}
              displayData={displayData}
              tabData={this.getTabs()}
              admin={this.isAdmin()}/>
          </div>

          <div className={"content " + themeClass} style={!this.props.isLoggedIn ? login_background : {}}>
            <div className="innerContainer">
              <Row>
                <Col xs={12}>
                  <Row>{this.props.children}</Row>
                  <Row><Footer /></Row>
                </Col>
              </Row>
            </div>
          </div>
          <Notifications notifications={this.props.notifications} />
        </div>
      );
    } else {
      return (null);
    }
  }
}

function mapStateToProps(state, ownProps) {
  // console.log('mappin state to props in appcontainer');
  // console.log(state);
  // console.log(ownProps);
  return {
    details: state.APIReducer.auth.details,
    isLoggedIn: state.APIReducer.auth.loggedIn,
    style : state.ConfigReducer.userPage,
    headerTabs : state.ConfigReducer.headerTabs,
    userType : state.APIReducer.auth.userType,
    redirectUrl: ownProps.location.pathname,
    notifications : state.notifications
  }
}
function mapDispatchToProps(dispatch) {
  // console.log('mappin dispatch to props');
  // console.log(dispatch);
  return {
    cookieAuth: bindActionCreators(cookieAuth, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js